<div
  class="flex items-center justify-between w-full max-w-[95vw] sm:min-w-[416px]"
>
  <div class="flex items-center space-x-2">
    <div class="flex-shrink-0" *ngIf="data.infoIcon">
      <mat-icon>info</mat-icon>
    </div>
    <p class="break-words leading-relaxed flex-1" [innerHTML]="data.message | translate: data.translateParams | nl2br">
      
    </p>
  </div>

  <div class="flex items-end justify-center space-x-2">
    <button
      mat-stroked-button
      *ngIf="data.action && !isMultinline"
      (click)="onAction()"
    >
      {{ data.action | translate }}
    </button>

    <mat-icon (click)="close()">close</mat-icon>
  </div>
</div>

<div *ngIf="isMultinline && !data.hideActions" class="mt-2 pl-8">
  <button mat-stroked-button class="px-4 py-1" (click)="onAction()">
    {{ data.action! | translate }}
  </button>
</div>
